module.exports = __webpack_public_path__ + "media/src/images/site-top/illust1-0aae670dfd473f018fc78dd457a0017f.png";